import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationsAddressee } from '../../actions/notificationsActions';
import { acceptCommunityRequest, checkMemberInZone, exitFromZone, getCommunity, sendToCommunityARequest } from '../../actions/userActions';
import ZoneView from '../../containers/Zones/Zone';

const Zone = ({ match, routes }) => {
  const dispatch = useDispatch()
  const { communityInfo, isLoadingCommunity, inCommunity, loadingInComunity } = useSelector(state => state.userInfo)
  useEffect(() => {
    dispatch(getCommunity(match.params.zoneId));
    dispatch(checkMemberInZone(match.params.zoneId))

    return () => {

    };
  }, [match.params.zoneId]);
  const exitZone = () => {
    //alert("salio de la zona")
    dispatch(exitFromZone(communityInfo._id))
  }
  const sendRequest = () => {
    dispatch(sendToCommunityARequest(communityInfo._id))
  }
  const aceptInvite = (id) => {
    dispatch(acceptCommunityRequest(inCommunity._id,true))
    dispatch(getNotificationsAddressee())
  }
  return (
    <ZoneView aceptInvite={aceptInvite} isLoading={loadingInComunity && isLoadingCommunity} inCommunity={inCommunity} exitZone={exitZone} zone={communityInfo} routes={routes} sendRequest={sendRequest} />
  )
};

export default Zone;
